import React from 'react'
import { IconProps } from '../../../common/types'

const ReportsIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M8.734 4.908H6.556c-1.203 0-2.178.995-2.178 2.222v13.338c0 1.228.975 2.223 2.178 2.223h10.888c1.203 0 2.178-.995 2.178-2.223V7.13c0-1.227-.975-2.222-2.178-2.222h-2.178m-6.532 0c0 1.227.975 2.222 2.177 2.222h2.178c1.202 0 2.177-.995 2.177-2.222m-6.532 0c0-1.228.975-2.223 2.177-2.223h2.178c1.202 0 2.177.995 2.177 2.223M12 12.688h3.266M12 17.134h3.266m-6.532-4.446h.01m-.01 4.446h.01"
      ></path>
    </svg>
  )
}

export default ReportsIcon
